import type { NoteActivity } from "@tandemdiabetes/sugarmate-api-react-client"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"

interface Props extends ComponentPropsWithoutRef<"div"> {
  activity: NoteActivity;
}

export const NoteActivityTitle = forwardRef<HTMLDivElement, Props>(
  function NoteActivityTitle(props: Props, ref: Ref<HTMLDivElement>) {
    const {
      activity,
      ...htmlDivProps
    } = props

    return (
      <div
        {...htmlDivProps}
        ref={ref}
      >
        {activity}
      </div>
    )
  },
)
